import moment from 'moment';

function convertFromAndToDateFromStrToTs(fromDate, toDate) {
    let fromTs = moment(fromDate).toDate();
    fromTs.setHours(0);
    fromTs.setMinutes(0);
    fromTs.setSeconds(0);
    fromTs.setMilliseconds(0);
    fromTs = +fromTs;

    let toTs = moment(toDate).toDate();
    toTs.setHours(23);
    toTs.setMinutes(59);
    toTs.setSeconds(59);
    toTs.setMilliseconds(0);
    toTs = +toTs;

    return { fromTs, toTs };
}

export default convertFromAndToDateFromStrToTs;
